import { NgModule } from '@angular/core';
import { ToggleButtonGroupComponent } from '@fc-shared/ui/toggle-button/toggle-button-group.component';
import { ToggleButtonComponent } from '@fc-shared/ui/toggle-button/toggle-button.component';

@NgModule({
  imports: [ToggleButtonGroupComponent, ToggleButtonComponent],
  exports: [ToggleButtonGroupComponent, ToggleButtonComponent],
})
export class ToggleButtonModule {}
